import React from 'react'
import createIcon from '@/lib/create-icon'

export const ToggleSVGIcon = createIcon(
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3571_6626)">
      <path d="M2.66699 14.5V9.83333M2.66699 7.16667V2.5M8.00033 14.5V8.5M8.00033 5.83333V2.5M13.3337 14.5V11.1667M13.3337 8.5V2.5M0.666992 9.83333H4.66699M6.00033 5.83333H10.0003M11.3337 11.1667H15.3337" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3571_6626">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>,

)
